import React from 'react';
import Main from './views tree/Main';

function App() {
  return (
    <Main />
  );
}

export default App;
